<form [formGroup]="documentForm" class="document-container">
  <div
    formArrayName="dynamicFieldsForm"
    class="flex flex-row flex-wrap justify-between"
    >
    @if (arrayItems?.length) {
      <label
        style="color: #010b18; font-family: Open Sans; font-style: normal; font-weight: 700; font-size: 18px; margin: 16px 0px 16px 12px"
        class="array-item-title section-lable"
        >General Information
        <span style="color: #010b18" matTooltip="Fields displayed are based on the selected template." class="material-icons info-icon-custom"
          >info</span
          >
        </label>
      }

      @for (arrayItem of arrayItems; track arrayItem; let i = $index) {
        <div
          [formGroupName]="'0'"
          [ngStyle]="{ width: arrayItem?.width ? (arrayItem?.width == '99%' ? '100%' : arrayItem?.width) : '100%' }"
          class="dynamic-form-field-container"
          >
          @if (arrayItem?.type == 'Section' && arrayItem.label != 'General Information') {
            <label
              style="color: #25508e"
              class="array-item-title section-lable"
              >{{ arrayItem.label }}
              @if (arrayItem?.label) {
                <span
                  matTooltip="Fields displayed are based on the selected template."
                  class="material-icons info-icon-custom"
                  >info</span
                  >
                }
              </label>
            }
            @if (arrayItem?.type == 'email') {
              <div style="width: 100% !important">
                <mat-form-field
                  appearance="fill"
                  [floatLabel]="'always'"
                  [ngClass]="'add-automtic-form-desing'"
                  style="width: 100% !important"
                  class="automtic-form-desing-form-only"
                  >
                  @if (arrayItem?.label) {
                    <mat-label class="automtic-form-desing-lable">
                      {{ arrayItem.label }}
                      @if (arrayItem?.isRequired) {
                        <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                  }
                  <input
                    matInput
                    [placeholder]="arrayItem?.placeholder"
                    type="email"
                    [formControlName]="arrayItem?.formControlName"
                    />
                  </mat-form-field>
                </div>
              }
              @if (arrayItem?.type == 'text') {
                <div style="width: 100% !important">
                  @if (arrayItem?.label) {
                    <mat-form-field
                      [floatLabel]="'always'"
                      appearance="fill"
                      [floatLabel]="'always'"
                      [ngClass]="'add-automtic-form-desing'"
                      style="width: 100% !important"
                      class="automtic-form-desing-form-only"
                      >
                      <mat-label class="automtic-form-desing-lable">
                        {{ arrayItem.label }}
                        @if (arrayItem?.isRequired) {
                          <span class="automtic-form-desing-required-sign"> * </span>
                        }
                      </mat-label>
                      @if (arrayItem?.makeEyeField) {
                        <input
                          matInput
                          [placeholder]="arrayItem?.placeholder"
                          [type]="arrayItem.setDefaultEyeField  ? 'password' : 'text'"
                          [formControlName]="arrayItem?.formControlName"
                          />
                      }
                      @if (!arrayItem?.makeEyeField) {
                        <input
                          matInput
                          [placeholder]="arrayItem?.placeholder"
                          [formControlName]="arrayItem?.formControlName"
                          />
                      }
                      @if (arrayItem?.makeEyeField) {
                        <button
                          mat-icon-button
                          matSuffix
                          (click)="arrayItem.setDefaultEyeField = !arrayItem.setDefaultEyeField"
                          [attr.aria-label]="'Hide password'"
                          >
                          <mat-icon>{{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                        </button>
                      }
                    </mat-form-field>
                  }
                </div>
              }
              @if (arrayItem?.type == 'number') {
                <div style="width: 100% !important">
                  <mat-form-field
                    appearance="fill"
                    [floatLabel]="'always'"
                    [ngClass]="'add-automtic-form-desing'"
                    style="width: 100% !important"
                    class="automtic-form-desing-form-only"
                    >
                    @if (arrayItem?.label) {
                      <mat-label class="automtic-form-desing-lable">
                        {{ arrayItem.label }}
                        @if (arrayItem?.isRequired) {
                          <span class="automtic-form-desing-required-sign"> * </span>
                        }
                      </mat-label>
                    }
                    <input
                      matInput
                      id="target"
                      [placeholder]="arrayItem?.placeholder"
                      pattern="\d+"
                      type="text"
                      [formControlName]="arrayItem?.formControlName"
                      />
                    </mat-form-field>
                  </div>
                }
                @if (arrayItem?.type == 'date') {
                  <div style="width: 100% !important">
                    <mat-form-field
                      appearance="fill"
                      [floatLabel]="'always'"
                      [ngClass]="'add-automtic-form-desing'"
                      style="width: 100% !important"
                      class="automtic-form-desing-form-only"
                      >
                      @if (arrayItem?.label) {
                        <mat-label class="automtic-form-desing-lable">
                          {{ arrayItem.label }}
                          @if (arrayItem?.isRequired) {
                            <span class="automtic-form-desing-required-sign"> * </span>
                          }
                        </mat-label>
                      }
                      <input
                        matInput
                        [matDatepicker]="dp3"
                        (dateChange)="arrayItem.triggerType"
                        (click)="dp3.open()"
                        [formControlName]="arrayItem?.formControlName"
                        />
                        <mat-datepicker-toggle  matSuffix [for]="dp3"></mat-datepicker-toggle>
                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                      </mat-form-field>
                    </div>
                  }
                  @if (arrayItem?.type == 'select') {
                    <div style="width: 100% !important">
                      <mat-form-field
                        appearance="fill"
                        [floatLabel]="'always'"
                        [ngClass]="'add-automtic-form-desing'"
                        style="width: 100% !important"
                        class="automtic-form-desing-form-only"
                        >
                        <mat-label class="automtic-form-desing-lable">
                          {{ arrayItem.label }}
                          @if (arrayItem?.isRequired) {
                            <span class="automtic-form-desing-required-sign"> * </span>
                          }
                        </mat-label>
                        <mat-select
                          matNativeControl
                          disableOptionCentering
                          [placeholder]="arrayItem?.placeholder"
                          [formControlName]="arrayItem?.formControlName"
                          >
                          @for (item of arrayItem?.options; track item) {
                            <mat-option [value]="item?.value">
                              {{ item?.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (arrayItem?.type == 'largeText') {
                    <div style="width: 100% !important">
                      <!-- <ngx-editor-field
                      [mode]="'add'"
                      (bookTitleCreated)="onBookAdded($event)"
                      [arrayItem]="arrayItem"p
                      [formControlValue]="documentForm.controls.dynamicFieldsForm.controls[0].controls[arrayItem?.formControlName].value"
                      >
                    </ngx-editor-field> -->
                  </div>
                }
                @if (arrayItem?.type == 'checkBox') {
                  <div style="height: 45.93px !important; padding-top: 10px">
                    <mat-checkbox class="automatic-form-checkbox" [ngClass]="'add-automtic-form-desing'" [formControlName]="arrayItem?.formControlName">
                      <mat-label class="automtic-form-desing-lable">
                        {{ arrayItem.label }}
                        @if (arrayItem?.isRequired) {
                          <span class="automtic-form-desing-required-sign"> * </span>
                        }
                      </mat-label>
                    </mat-checkbox>
                  </div>
                }
              </div>
            }


          </div>

        </form>